import { useState, useCallback, useEffect, useRef } from "react";
import { FloatingHint } from "@rapid/components/FloatingHint";
import { useAnalytics } from "@rapid/contexts/AnalyticsContext";
import { AnalyticsFlowEvent } from "@rapid/analytics/types";

const DELETE_BUTTON_CLICK_THRESHOLD = 3;

// Dispatched by AnnotationCanvas when the delete button is clicked
export const DELETE_BUTTON_CLICK_EVENT = "annotation-delete-button-click";

export const BackspaceHint = () => {
    const [clickCount, setClickCount] = useState(0);
    const [isDismissed, setIsDismissed] = useState(false);
    const { track } = useAnalytics();
    const hasTrackedRef = useRef(false);

    useEffect(() => {
        const handler = () => setClickCount((prev) => prev + 1);
        window.addEventListener(DELETE_BUTTON_CLICK_EVENT, handler);
        return () => window.removeEventListener(DELETE_BUTTON_CLICK_EVENT, handler);
    }, []);

    const shouldShowHint = clickCount >= DELETE_BUTTON_CLICK_THRESHOLD && !isDismissed;

    useEffect(() => {
        if (shouldShowHint && !hasTrackedRef.current) {
            track({
                event: AnalyticsFlowEvent.BACKSPACE_DELETE_HINT_SHOWN,
                data: { deleteButtonClickCount: clickCount }
            });
            hasTrackedRef.current = true;
        }
    }, [shouldShowHint, clickCount, track]);

    const handleDismiss = useCallback(() => {
        setIsDismissed(true);
    }, []);

    if (!shouldShowHint) return null;

    return (
        <FloatingHint
            isVisible={shouldShowHint}
            message={
                <span>
                    Hint: You can delete a label by pressing{" "}
                    <span className="rounded border border-gray-500 bg-gray-700 px-1.5 py-0.5 font-mono text-xs">
                        {" "}
                        DELETE
                    </span>{" "}
                    on your keyboard.
                </span>
            }
            onDismiss={handleDismiss}
        />
    );
};
